import { Divider, Typography } from '@material-ui/core'
import React from 'react'

import { gregorianToJalaali } from '../../../../helpers/date'
import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate, lang } from '../../../../localization'
import { ChargePerDay } from '../../../../types/cart'
import { Currency } from '../../../../types/currency'
import { useStyles } from './styles/index.styles'

type PerDayChargeRowProps = {
  isTotal?: boolean
  total?: number
  chargePerDay?: ChargePerDay
  curruncy: Currency
}
const PerDayChargeRow: React.FC<PerDayChargeRowProps> = ({
  isTotal,
  total,
  chargePerDay,
  curruncy
}: PerDayChargeRowProps) => {
  const classes = useStyles()

  return (
    <>
      {isTotal ? <Divider className={classes.divider} /> : ''}
      <div
        className={[classes.tableRow, isTotal ? classes.tableRowDark : ''].join(
          ' '
        )}>
        <Typography variant="h6" className={classes.cell}>
          {isTotal
            ? getTranslate('Total')
            : lang === 'fa'
            ? gregorianToJalaali(chargePerDay?.date || '')
            : chargePerDay?.date}
        </Typography>
        <Typography variant="h6" className={classes.cell}>
          {isTotal ? '' : chargePerDay?.charge.itemName}
        </Typography>
        <Typography variant="h6" className={classes.cell}>
          {isTotal ? '' : getTranslate('Per Room/Day')}
        </Typography>
        <Typography variant="h6" className={classes.cell}>
          {isTotal ? '' : chargePerDay?.charge.quantity}
        </Typography>
        <Typography variant="h6" className={classes.cell}>
          {isTotal
            ? ''
            : chargePerDay?.charge.discount
            ? `${addCommaToPrice(chargePerDay?.charge.discount)} ${getTranslate(
                curruncy || ''
              )}`
            : 0}
        </Typography>
        <Typography variant="h6" className={classes.cell}>
          {isTotal
            ? ''
            : chargePerDay?.charge.rate
            ? `${addCommaToPrice(chargePerDay?.charge.rate)} ${getTranslate(
                curruncy || ''
              )}`
            : 0}
        </Typography>
        <Typography variant="h6" className={classes.cell}>
          {isTotal
            ? total
              ? `${addCommaToPrice(total)} ${getTranslate(curruncy || '')}`
              : 0
            : `${addCommaToPrice(chargePerDay?.charge.total!)} ${getTranslate(
                curruncy || ''
              )}`}
        </Typography>
        <Typography variant="h6" className={classes.cell}>
          {isTotal ? '' : '-'}
        </Typography>
      </div>
    </>
  )
}

export default PerDayChargeRow
